import React from 'react'

const PageTitleBanner = ({title}) => {
  return (
    <div className="page-header title-area">
    <div className="header-title" style={{background: 'url(images/bg/page-header1.jpg)'}}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="page-title">{title}</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="breadcrumb-area">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <nav className="breadcrumb"><span>
                <a className="home" href="#"><span>Home</span></a>
              </span><i className="fa fa-angle-right" aria-hidden="true" />
              <span><span>{title}</span></span>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default PageTitleBanner